const varType = function(v){
  if(typeof v === "number" && Number.isInteger(v)){
    return "int"
  } else if(typeof v === "number" && !Number.isInteger(v)){
    return "float"
  } else if(typeof v === "string"){
    return "string"
  } else if(typeof v === "boolean"){
    return "boolean"
  } else if(Array.isArray(v)){
    return "array"
  } else {
    // Catch all for everything else
    return "string"
  }
}

const stringify = function(val){
  //Not sure if this is needed, but maybe in the future for more complex objects
  const stringifyFunctions = {
    "int" : v=>JSON.stringify(v),
    "float" : v=>JSON.stringify(v),
    "boolean" : v=>JSON.stringify(v),
    "string" : v=>v,
    "array" : v=>JSON.stringify(v),
  }
  return stringifyFunctions[varType(val)](val);
}

const parse = function(val, varType){
  //Not sure if this is needed, but maybe in the future for more complex objects
  const parseFunctions = {
    "int" : v=>parseInt(v),
    "float" : v=>parseFloat(v),
    "boolean" : v=>JSON.parse(v),
    "string" : v=>v,
    "array" : v=>JSON.parse(v),
  }
  return parseFunctions[varType](val);
}



export default {
  
  created(){
    this._lsCreate()
  },
  methods : {
    _lsCreate : function(){
      let ls = this.$data.ls
      let p = this.$props
      let componentName = p && p.lsComponentName ? p.lsComponentName : this.$options.name;
      if (componentName.length === 0){
        console.error('localstorage mixin requires a component name')
        return;
      }

      if(ls !== undefined && Object.keys(ls).length > 0){
        Object.keys(ls).forEach(key=>{
          
          const keyVarType = varType(this.$data.ls[key]);
          const lsKeyName = `$ls_${componentName}_${key}_${keyVarType}`
          
          //Get or Set Default Value
          if (localStorage.getItem(lsKeyName) === null){
            localStorage.setItem(lsKeyName, stringify(this.$data.ls[key]))
          } else {
            this.$data.ls[key] = parse(localStorage.getItem(lsKeyName), keyVarType)
          }
          
          this.$watch(`ls.${key}`, function(val){localStorage.setItem(lsKeyName, stringify(val))})
          
        })
      }
      
      // console.log('mixin loaded')
    }
  }
}